import { Dispatch, AnyAction } from 'redux';
import { AppState } from '../redux';
import axios, { AxiosResponse, AxiosError } from 'axios';
import {
    STORE_MATERIALFILES_DATA
} from 'src/reducers/materialFiles';

export const getMaterialFiles = async (dispatch: Dispatch<AppState>, getState: () => AppState) => {
    const custcode = getState().userProfileData.userProfiledata.custcode || '';
    axios({
        method: 'get',
        url: `${getState().environment.API_URL}getMaterialFiles?custcode=${custcode}`,
        // url: `${getState().environment.API_URL}getMaterialFiles?custcode=${custcode}`,
        headers: {
            sessionid: getState().user.userDetails.s || ''
        },
    }).then(function (response: AxiosResponse) {
        const materialFilesData = response.data;
        // const materialFilesData = null;
        dispatch({ type: STORE_MATERIALFILES_DATA, materialFilesData } as AnyAction);
    }).catch(function (error: AxiosError) {
        // ==> console.error(error);
    });
};



// WEBPACK FOOTER //
// ./src/actions/materialFilesAction.ts